export default "__VITE_ASSET__BwwkhK2R__"